var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconSuccessColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.403 19.403 25 12.5 25S0 19.403 0 12.5 5.597 0 12.5 0 25 5.597 25 12.5z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCFF90",
    d: "M19.126 6.626l-8.501 8.498-3.501-3.498-1.748 1.748 5.249 5.252L20.874 8.374z"
  }))));
}

export default SvgCommonIconSuccessColor;